// Job constants kept in sync with backend (see /api/jobs/categories).
export const JOB_CATEGORIES = [
  "Tech", "Hospitality", "Creative", "Trades",
  "Sales/Marketing", "Operations", "Education", "Other",
];

export const EMPLOYMENT_TYPES = [
  { id: "full_time",  label: "Full-time" },
  { id: "part_time",  label: "Part-time" },
  { id: "contract",   label: "Contract" },
  { id: "internship", label: "Internship" },
  { id: "temporary",  label: "Temporary" },
];

export const SALARY_PERIODS = [
  { id: "hour",    label: "/hr" },
  { id: "day",     label: "/day" },
  { id: "week",    label: "/wk" },
  { id: "month",   label: "/mo" },
  { id: "year",    label: "/yr" },
  { id: "project", label: "/project" },
];

const SYMBOL = { USD: "$", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$", JPY: "¥" };

export function formatSalary(j) {
  const sym = SYMBOL[j?.currency] || `${j?.currency || "USD"} `;
  const periodLabel = (SALARY_PERIODS.find(p => p.id === (j?.salary_period || "year")) || {}).label || "";
  if (j?.salary_min == null && j?.salary_max == null) return "Negotiable";
  const fmt = (n) => Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
  if (j.salary_min != null && j.salary_max != null && j.salary_min !== j.salary_max)
    return `${sym}${fmt(j.salary_min)}–${sym}${fmt(j.salary_max)}${periodLabel}`;
  if (j.salary_min != null) return `${sym}${fmt(j.salary_min)}+${periodLabel}`;
  return `${sym}${fmt(j.salary_max)}${periodLabel}`;
}

export function employmentLabel(id) {
  return (EMPLOYMENT_TYPES.find(e => e.id === id) || {}).label || id;
}
